var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecomendation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.61 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#340cdd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.91,127.26A194.8,194.8,0,0,1,68.23,133a190.81,190.81,0,0,1,47.83,19.76V31.08C111.13,26.5,94.7,12.22,75.43,5.72,69.1,3.58,54.72,0,29.56,0c-2.06,0-4.13,0-6,.08L15.47,127.43C17.48,127.34,20.39,127.26,23.91,127.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.7,127.26c3.52,0,6.43.08,8.43.17L215.08.08c-1.45,0-3.53-.08-6-.08-25.16,0-39.54,3.58-45.87,5.72-19.27,6.5-35.7,20.78-40.63,25.36V152.71a194.26,194.26,0,0,1,48.13-19.54C187,129.1,203.39,127.26,214.7,127.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.58,17a4.17,4.17,0,0,0-8.32.55L230,133.77c-1.72,0-3.7-.07-5.9-.07-12.95,0-32.31.94-51,5.38C151.2,144.26,130.72,154.6,119.3,161c-11.41-6.44-31.89-16.77-53.73-21.95-18.72-4.44-38.08-5.38-51-5.38-2.2,0-4.19,0-5.9.07L16.35,17.51A4.17,4.17,0,0,0,8,17L0,137.81a4.17,4.17,0,0,0,4.35,4.45c2.17-.1,5.71-.22,10.18-.22,12.5,0,31.16.9,49.1,5.15,23,5.47,45.15,17.38,53.58,22.25h0a4.66,4.66,0,0,0,.73.3,4.18,4.18,0,0,0,1.34.25h0a4.33,4.33,0,0,0,1.32-.24,4.43,4.43,0,0,0,.74-.31h0c8.43-4.87,30.54-16.78,53.57-22.25,17.94-4.25,36.61-5.15,49.11-5.15,4.47,0,8,.12,10.18.22a4.28,4.28,0,0,0,3.17-1.25,4.17,4.17,0,0,0,1.18-3.2Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecomendation);
export default __webpack_public_path__ + "static/media/recomendation.a4ea9ba3b0bdd831a7021e23bdadf761.svg";
export { ForwardRef as ReactComponent };